





















import { defineComponent, PropType } from "@vue/composition-api";
import OccButton from "@/components/Atoms/OccButton/index.vue";
import { ApiResponse } from "@/api/types";

export interface Props {
  eventEntryUsers: ApiResponse.EventEntryUser[];
  selectedEventEntryUsers: ApiResponse.EventEntryUser[];
}

export default defineComponent({
  name: "SelectionStatusChangeDrawer",
  props: {
    eventEntryUsers: {
      type: Array as PropType<Props["eventEntryUsers"]>,
      default: () => []
    },
    selectedEventEntryUsers: {
      type: Array as PropType<Props["selectedEventEntryUsers"]>,
      default: () => []
    }
  },
  components: {
    OccButton
  },
  emits: ["onClickSubmit"],
  setup(props, { emit }) {
    const onClickSubmit = () => {
      emit("onClickSubmit");
    };

    return {
      onClickSubmit
    };
  }
});
